// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"R_r_9zg","skipLink":"_2ddmVSH R_r_9zg"};